import { ICase } from "../types/case/case";
import { IIndexedCase } from "../types/case/caseIndexed";

export const getAgenciesFromCase = (caseData: IIndexedCase | ICase): string[] => {
  const { agencyCode, agenciesAccess } = caseData
  return [agencyCode, ...agenciesAccess ? Object.keys(agenciesAccess) : []]
}